import { render } from "./ClosedText.vue?vue&type=template&id=cea66f02"
import script from "./ClosedText.vue?vue&type=script&lang=js"
export * from "./ClosedText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__